<template>
  <div class="header">
    <div class="top-wrap">
      <div class="centerWidth h100p">
        <div class="header-con h100p d-flex d-just-between d-align-center">
          <div class="box">
            <img :src="domain + webconfig.pc_logo" alt="">
          </div>
          <div class="right-wrap">
            <div class="name-wrap" v-if="name && !ifShow" @click="toSet">{{name}}</div>
            <div class="name-wrap" v-if="name && ifShow" @click="toZX">退出登录</div>
            <div class="search d-flex d-align-center">
              <el-input type="text" v-model="keyword" placeholder="请输入搜索内容" @keyup.enter.native="toSearch"/>
              <button @click="toSearch">
                <img src="../assets/images/search.png" />
              </button>
            </div>
            <div class="title">{{webconfig.danwei}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="top-nav">
      <div class="centerWidth d-flex d-align-center list">
        <div class="tit" :class="cur == 0?'cur':''" @click="toPage('/',0)">首页</div>
        <span>|</span>
        <div class="tit" :class="cur == 1?'cur':''" @click="toPage('/about',1)">关于我们</div>
        <span>|</span>
        <div class="tit" :class="cur == 2?'cur':''" @click="toPage('/announcement',2)">通知公告</div>
        <span>|</span>
        <div class="tit" :class="cur == 3?'cur':''" @click="toPage('/policyNews',3)">政策新闻</div>
        <span>|</span>
        <div class="tit" :class="cur == 4?'cur':''" @click="toPage('/courseList',4)">课程展示</div>
        <span>|</span>
        <div class="tit" :class="cur == 5?'cur':''" @click="toPage1(1,5)">查询系统</div>
        <span>|</span>
        <div class="tit" :class="cur == 6?'cur':''" @click="toPage1(2,6)">在线学习</div>
        <span>|</span>
        <div class="tit" :class="cur == 7?'cur':''" @click="toPage1(3,7)">在线考试</div>
        <span>|</span>
        <div class="tit" :class="cur == 8?'cur':''" @click="toPage('/support',8)">技术支持</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  indexconfig
} from "@/api/index";
export default {
  name: 'topHeader',
  data() {
    return {
      cur:0,
      keyword:'',
      name:'',
      ifShow:false,
      copyright: {},
      webconfig:{},
      domain:''
    };
  },
  created() {
    console.log(this.$route.path)
    if (this.$route.path === '/home') {
      this.cur = 0
    } else if (this.$route.path === '/about') {
      this.cur = 1
    } else if (this.$route.path === '/announcement') {
      this.cur = 2
    } else if (this.$route.path === '/policyNews') {
      this.cur = 3
    } else if (this.$route.path === '/courseList') {
      this.cur = 4
    } else {
      this.cur = 0
    }
  },
  mounted() {
    if (localStorage.getItem('name')) {
      this.name = localStorage.getItem('name');
    }
    this.$bus.$on('setName', (value) => {
      this.name = value.data;
    });
    this.$bus.$on('refresh', (value) => {
      this.name = ''
    });

    this.getInfo()
  },
  methods: {
    getInfo() {
      indexconfig().then(res => {
        if (res.code == 1) {
          this.domain = res.data.domain
          this.copyright = res.data.copyright[0]
          this.webconfig = res.data.webconfig
          localStorage.setItem('first_bg',this.domain + res.data.webconfig.first_bg);
          localStorage.setItem('second_bg',this.domain + res.data.webconfig.second_bg);
        }
      })
    },
    toPage(url,num){
      this.cur = num
      this.$router.push({
        path: url,
        query: { }
      })
    },
    toPage1(type,num){
      this.cur = num
      let token = localStorage.getItem('token')
      if (token) {
        if ( type == 1 ) {
          this.$router.push({
            path: '/login?type=3',
            query: { }
          })
        }else if (type == 2) {
          this.$router.push({
            path: '/myCourseList',
            query: { }
          })
        }else if (type == 3) {
          this.$router.push({
            path: '/examList',
            query: { }
          })
        }
      }else {
        if ( type == 1 ) {
          this.$router.push({
            path: '/login?type=3',
            query: { }
          })
        }else if (type == 2) {
          this.$router.push({
            path: '/login?type=1',
            query: { }
          })
        }else if (type == 3) {
          this.$router.push({
            path: '/login?type=2',
            query: { }
          })
        }
      }
    },
    toSearch(){
      if (this.keyword.length < 2) {
        this.$message.warning('请输入两个及两个以上字符进行搜索')
        return
      }else {
        console.log(this.$route.path)
        if ( this.$route.path == '/search' ) {
          this.$bus.$emit('searchcon', {
            data: this.keyword
          })
        }else {
          this.$router.push({
            path: '/search',
            query: {  keyword:this.keyword }
          })
        }
      }
    },
    toSet(){
      this.ifShow = true
      this.$router.push({
        path: '/information',
        query: {}
      })
    },
    toZX(){
      localStorage.clear()
      this.$router.replace('/')
      this.name = ''
      this.ifShow = false
    },
  }
};
</script>

<style scoped lang="scss">
.header{
  .top-wrap{
    //background: rgb(38,103,197);
    background: #4884dbf7;
    height: 260px;
  }
  .top-nav{
    background: rgb(22,80,164);
    height: 66px;
    .list{
      height: 100%;
    }
    .tit{
      display: inline-block;
      width: 133px;
      color: #fff;
      font-size: 20px;
      text-align: center;
      box-sizing: border-box;
      vertical-align: top;
      position: relative;
      cursor: pointer;
    }
    span{
      display: inline-block;
      width: 1px;
      vertical-align: middle;
      color: #ffffff;
    }
    .tit.cur, .tit:hover {
      font-weight: bold;
      color: #fff;
      font-size: 22px;
      //height: 66px;
      //line-height: 55px;
    }
    .tit.cur:after, .tit:hover:after{
      display: inline-block;
      content: ' ';
      position: absolute;
      bottom: -10px;
      width: 30px;
      height: 3px;
      border-radius: 2px;
      background: #fff;
      left: 50%;
      margin-left: -15px;
    }
  }
}
.header-con{
  text-align: center;
  .logo{
    display: inline-block;
    margin-left: 5px;
  }
  .search{
    background: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    height: 45px;
    width: 290px;
    text-align: left;
    /deep/  input{
      padding: 0 15px;
      width: 100%;
      line-height: 45px;
      height: 45px;
      font-size: 15px;
      border: none;
    }
    input::-webkit-input-placeholder{
      color: #999;
    }
    input:-moz-placeholder{
      color: #999;
    }
    .input::-moz-placeholder{
      color: #999;
    }
    input:-ms-input-placeholder{
      color: #999;
    }
    button{
      text-align: center;
      line-height: 45px;
      height: 45px;
      padding-right: 16px;
    }
  }
  .title{
    font-size: 14px;
    color: #ffffff;
    text-align: end;
    margin-top: 15px;
  }
  .right-wrap{
    margin-top: 20px;
    position: relative;
    .name-wrap{
      cursor: pointer;
      position: absolute;
      top: -70px;
      right: 0;
      border: 1px solid #fff;
      display: flex;
      width: 120px;
      justify-content: center;
      color: #fff;
      font-weight: bold;
      border-radius: 43px;
      padding: 10px 0;
    }
  }
}
</style>
